import { render, staticRenderFns } from "./UserSignature.vue?vue&type=template&id=3598a62b&scoped=true"
import script from "./UserSignature.vue?vue&type=script&lang=js"
export * from "./UserSignature.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3598a62b",
  null
  
)

export default component.exports